export default function FixedButton() {
  const triggerElement = document.querySelector('.a-button.on-position')
  const targetElement = document.querySelector('.a-button.fixed-position')

  if (!triggerElement || !targetElement) {
    return
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  }

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      const isHiddenAndAboveViewport =
        !entry.isIntersecting && entry.boundingClientRect.top < 0

      if (isHiddenAndAboveViewport) {
        targetElement.classList.add('active')
      } else {
        targetElement.classList.remove('active')
      }
    })
  }

  const observer = new IntersectionObserver(observerCallback, observerOptions)

  observer.observe(triggerElement)
}
